import * as React from 'react';
import classNames  from 'classnames';
import ResultTableTotalCell from './TotalCell';
import StatusBadge from './StatusBadge';
import { getStatisticDetails } from 'src/helpers/api';
import { IStatisticsDepartmentItem, IStatisticsItem } from 'src/types/Statistics';
import { Column } from '../../types';

type ResultTableRowProps = {
  result: IStatisticsItem;
  columns: Column[];
};

const ResultTableRow = ({ result, columns }: ResultTableRowProps) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [details, setDetails] = React.useState<IStatisticsDepartmentItem[]>([]);
  const [isLoaded, setIsLoaded] = React.useState<boolean>(false);
  const themes = React.useMemo(() => {
    return result.theme.split(',')
      .map((theme) => theme.trim())
      .join(', ');
  }, [result.theme]);
  const categories = React.useMemo(() => {
    return result.categories.split(',')
      .map((category) => category.trim())
      .join(', ');
  }, [result.categories]);

  const toggle = React.useCallback(async () => {
    if (!isOpen && !isLoaded) {
      const nextDetails = await getStatisticDetails(result.courseCode);

      setIsLoaded(true);
      setDetails(nextDetails);
    }

    setIsOpen(!isOpen);
  }, [isOpen, isLoaded, details]);

  return (
    <React.Fragment>
      <div
        className={classNames(
          'flex items-center py-3 border-b border-gray-body cursor-pointer',
          isOpen && 'has-background-gray-300'
        )}
        onClick={toggle}
      >
        <div className="flex-none w-12 text-center">
        {result.isAdvertisement
          ? null
          : <StatusBadge status={result.courseStatus} />}
        </div>
        <div className="flex-none w-56">
          <div className="font-semibold f4">{result.courseName}</div>
          <div className="has-text-gray-600">Kursusnr.: {result.courseCode}</div>
        </div>
        <div className="flex-none w-40 pl-2">{result.departmentName}</div>
        <div className="flex-none w-48 pl-2">
          <div>{themes}</div>
          <div className="has-text-gray-600">{categories}</div>
        </div>
        <div className="flex-none text-right ml-auto pr-2">
          <ResultTableTotalCell columns={columns} item={result} />
        </div>
      </div>
      {isOpen && (
        <div className="has-background-gray-300">
          <div className="flex items-center border-b border-gray-body py-2">
            <div className="w-56 uppercase font-semibold ml-12">Afdeling</div>
          </div>
          {isLoaded && !details.length && (
            <div className="p-8 font-bold text-center">Ingen detaljer</div>
          )}
          {isLoaded && details.map((department) => (
            <div key={department.detailkursusid} className="flex items-center py-3 border-b border-gray-body">
              <div className="ml-12 flex-none">{department.departmentName}</div>
              <div className="ml-auto pr-2">
                <ResultTableTotalCell columns={columns} item={department} />
              </div>
            </div>
          ))}
        </div>
      )}
    </React.Fragment>
  );
};

export default ResultTableRow;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Reports/components/ResultTable/Row.tsx